// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/layout-template.js';

import { paths } from '../generated/layout-template';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('layout-template', Original, paths);
